<template>
  <v-dialog v-model="show" max-width="500" persistent>
    <v-card>
      <v-container fluid grid-list-md>
        <v-row style="margin:0">
          <p>¿Está seguro de que se encuentra en curso el servicio?</p>
        </v-row>
        <v-row style="margin:0">
          <v-spacer />
          <v-btn
            color="rapired"
            dark
            @click="$emit('close-dialog')"
            style="margin-right:24px"
            >NO</v-btn
          >
          <v-btn
            color="secondary"
            @click="
              $emit('confirm-checkin');
              $emit('close-dialog');
            "
            >SI</v-btn
          >
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    show: Boolean
  }
};
</script>
